import PropTypes from 'prop-types';

import React from 'react';

// Page object
class pageFooter extends React.Component {
  static defaultProps = {className: ''};

  static propTypes = {
    children: PropTypes.any,
    style: PropTypes.object,
  };

  render() {
    return (
      <footer id='page-footer' style={this.props.style}>
        <div className='footer-spacer'/>
        <div className='footer-content'>
          <div className={'container ' + this.props.className}>
            {this.props.children}
          </div>
        </div>
      </footer>
    );
  }
}

export default pageFooter;
